import { Button } from "components/DesignSystem/Button/Button";
import {
  IRS_SUBMISSION_STATUSES,
  IRSSubmissionStatus as IRSSubmissionStatusType,
} from "store/apis/IRSDetails";

export const IRSSubmissionStatus = ({
  status,
}: {
  status: IRSSubmissionStatusType["status"];
}) => {
  if (status === IRS_SUBMISSION_STATUSES.ACCEPTED) {
    return (
      <Button type="button" disabled customType="primary_outlined">
        Approved
      </Button>
    );
  }

  if (status === IRS_SUBMISSION_STATUSES.REJECTED) {
    return (
      <Button type="button" disabled customType="primary_outlined">
        Rejected
      </Button>
    );
  }

  return (
    <Button type="button" disabled customType="primary_outlined">
      Submission in progress
    </Button>
  );
};
